export enum TransactionTypeEnum {
    DEBIT = "Debit",
    CREDIT = "Credit"
}
